
import React, {Component} from 'react';
import {Button, Form, Input, Icon, Checkbox} from 'antd';
import {MaskedFormInput} from '../../../common/masked-form-input';

class SignFormComponent extends Component {

  state = {
    confirmDirty: false,
  };

  phoneRef = null;
  nameRef = null;

  componentDidMount() {
    console.log('ref', this.phoneRef)
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="sign-form">
        <Form.Item label="ФИО">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Пожалуйста введите ФИО' }],
          })(
            <Input size="large" ref={ref => this.nameRef = ref} prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} type="name" placeholder="Как вас зовут ?" />
          )}
        </Form.Item>
        <MaskedFormInput
          form={this.props.form}
          mask={'\+7 (111) 111-11-11'}
          label={'Телефон'}
          name={'phone'}
          prefix={<Icon type={'phone'} style={{ color: 'rgba(0,0,0,.25)' }}/>}
          rules={[
            { required: true, message: 'Введите номер' },
            {
              validator: this.validatePhone,
            },
          ]}
        />
        <Form.Item label="Email">
          {getFieldDecorator('email', {})(
            <Input size="large" ref={ref => this.nameRef = ref} prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Ваш емейл" />
          )}
        </Form.Item>
        <Form.Item label="Пароль" hasFeedback>
          {getFieldDecorator('password', {
            rules: [
              { required: true, message: 'Пожалуйста введите ваш пароль' },
              {
                validator: this.validateToNextPassword,
              },
            ],
          })(
            <Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Пароль" />
          )}
        </Form.Item>
        <Form.Item label="Повторите пароль">
          {getFieldDecorator('confirm', {
            rules: [
              { required: true, message: 'Пожалуйста повторите пароль' },
              {
                validator: this.compareToFirstPassword,
              },
            ],
          })(
            <Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Повторите пароль" />
          )}
        </Form.Item>
        <Form.Item style={{ marginTop: 12 }}>
          <Button size="large" type="primary" htmlType="submit" className="lg-btn" loading={this.props.loading}>
            Зарегистрироваться
          </Button>
        </Form.Item>
      </Form>
    );
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submit({
          ...values,
          phone: values.phone.replace(/\D/g, '').slice(1),
        });
      }
    });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Пароли не совпадают');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  validatePhone(rule, value, callback) {
    const valueNums = value && value.replace(/\D/g, '');
    if (valueNums && valueNums.length !== 11) {
      callback('Введите правильный номер телефона');
    } else {
      callback();
    }
  }

}


export const SignForm = Form.create({ name: 'sign_form' })(SignFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/auth/forms/sign.js